import {IMedicalInstitution, IMedicalInstitutionPayload} from "../../models/medical"
import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {IValidationFieldErrorItem} from "../../models/validation"
import {AxiosError} from "axios"

interface IMedicalState {
  list: IMedicalInstitution[]
  pages: number
  totalCount: number
  pageSize: number
  currentPage: number
  isLoading: boolean
  isAdding: boolean
  isUpdating: boolean
  error: any
  fetchError: any
}

const initialState: IMedicalState = {
  list: [],
  pages: 0,
  totalCount: 0,
  pageSize: 10,
  currentPage: 1,
  isLoading: false,
  isAdding: false,
  isUpdating: false,
  error: "",
  fetchError: ""
}

export const medicalSlice = createSlice({
  name: "medical",
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<IMedicalInstitutionPayload>) {
      state.isLoading = false
      state.list = action.payload.list || []
      state.pages = action.payload.pages
      state.totalCount = action.payload.totalCount
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false

      if (action.payload.response?.status === 403) {
        state.fetchError = "У вас нет разрешения на эту операцию!"
      } else {
        state.fetchError = action.payload.message
      }
    },
    adding(state) {
      state.isAdding = true
    },
    addSuccess(state, action: PayloadAction<IMedicalInstitution>) {
      state.isAdding = false
    },
    addError(state, action: PayloadAction<IValidationFieldErrorItem[]>) {
      state.isAdding = false
      state.isUpdating = false

      const obError: any = {}

      action.payload.forEach(item => {
        obError[item.field] = item.message
      })

      state.error = obError
    },
    updating(state) {
      state.isUpdating = true
    },
    updateSuccess(state) {
      state.isUpdating = false
    },
    clearFieldError(state, action: PayloadAction<string>) {
      delete state.error[action.payload]
    },
    clearAllErrors(state) {
      state.error = {}
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    }
  }
})

export default medicalSlice.reducer